import { medicalPatient, officeAsset, retailExhibition } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';

export default {
  desc: 'NFC (Near Field Communication) là công nghệ giao tiếp tầm gần, cho phép giao tiếp không dây ở cự ly ngắn. Công nghệ này sử dụng sóng vô tuyến nhỏ để trao đổi dữ liệu trong phạm vi rất gần.',
  keywords: 'NFC, theo dõi vị trí, truyền thông không dây, quản lý tài sản, theodoi vitri, truyenthong khong day, quanly taisan.',
  ogSite: 'NFC là gì',
  title: 'NFC là gì',
  ogUrl: 'https://orbro.io/vi/blog/nfc',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDlx0aose_UUwB8yAMLpMzvTdJK7dGM_ga67nWJqGp-Ad-0qXiKbUEUjAYHHCIw3c5fBJeOurZ9GbBlOLASQQ-fxRGXYfqb0RRl8SAXz05tRfZVuRggCXCN4Lhgi5bmQUDXYI9RvZTvlt-aRguSSi_Stihe1t7AUtepg-f_OTkuBEX5XDNmq1mSEBJVgqC26dYfGuJh3zgT12nYtPK60Bz8xB5ydx2cmvaAbP-No0hvZIWMciZv6XarrpKcR-Eu6YSdcsFOZ3J9wjVTeyyc6S-gVqoxW4abVCEfQaItklbow0uqPjlPT_KHGCGQa0SKOW97pUKx0PO8uSBpJMD6AzeJ4Yh-01yRQqpC6vcBsmNvEBxMvLvTm8BX5mRmBV48v6kHK_P7WycSemW5wnW58cEHX5Wjo2tV2tTJHX9y_qWwOZZWX7eFx73V0WmX-vG4ABxNwFr7u-p3TKA6nWMxJzwGyLw_9ouTexsqnfiBXf8MhruRLbrNobB19ErL_DHgZi4kPuI8PDDdT4kvxwE9lt4LpJuArzzdpvwhT4XnDrFl73C616KHcorzOcrOJxw-jzKhFvc-q17_3S--zh2PcMpG5cvL7DJ1Cgy62atJyXB5IB67bDeOUAnB_Zr3RdAUcVBg3_yADYB7htLduaNVCYlC8F9ucLtTOKYqDU_Kc0G53AHrpmiqbbWxLOyGamXVkCO9EzJaWC8EVDcclcnwMUWf_5vC_tIg8wnNp4nSycN0vVAfm-iukMGeHV3onRhtyGa--Q_31wtjzULC5n1ffWD2DgX0LCxksQOCkOmzWPFRhGC-UpLo1hUE6ar64oJbH06kISvVcqIqPYMLHIqWcMchD9FMPlBI2P0XtEJaZtNQ8OQ7XdAJzRXi6TK_jo16h0jAW9Bnh5sv9BA0eJoEQz4d0jD1wMwPB9StiMAHG_6pTNleKUOO92VU0weNP0U6p8gqceFhBSgierz4ukU8ud1rti_cnmtvPUHKNnPGoKMb-np6KexGgI3D9XWzzAsaUrAwziO87m2zHYt2SezQ3urRH9gG1yhokna4WTjfrxED9WfE2yI9uC3xMuALyZLompGIZk-mz9k1N8O4kZRHSLtIt_TQSUDILXDQsIwVMeMs1q_U9i6L10APLVQAjMZQL5dxa557zkCPB59Zytf72ASMHtp9TL6LGnpV5bPGGl3GSNPkH8sjR7UkuMmEFrUbbohLMbhHtxGneSDUtRJO7bdQsysoOK_-ZxsXqnkQVa1KX-J153QU3yI4IlaViIpjxY9w5kptwJPL_WFlXcjUnR-JnSu5c3FPe8y8gae7yt91cT6KECSmJelkYxaEan1q9_hAgXCvb24BKiRGWrNMAacUoPz8hljTI0cf8fB9GuDiPoqYgxJKcZFdicKosSD3SZMXnLbF4hZE96gFYFWuOIetfv7pzlsg08ZZ0EiklpgY1dshXnDmrLrKcnB4v_mWgvqKA1tyQnCZrAYyX-Z7zW_cj00TQX28EqAsV3cAkEVZTs_ClA1g-xHvUBIm-0logZKUhbQUT9TBz5eip_Aw_rexmWpOV4XcV=w1984-h1214',
  ogType: 'website',
  date: '2024-01-11',
  tag1: '#NFC',
  tag2: '#Theodoivitri',
  tag3: '#Truyenthongkhongday',
  tag4: '#Quanlytaisan',
  text: [
    {
      head: 'NFC là gì?',
      subHead: '',
      desc: 'NFC (Near Field Communication) là công nghệ giao tiếp tầm gần, cho phép giao tiếp không dây ở cự ly ngắn. Công nghệ này sử dụng sóng vô tuyến nhỏ để trao đổi dữ liệu trong phạm vi rất gần. Nó chủ yếu được ứng dụng để truyền thông tin tiện lợi giữa smartphone và các thiết bị điện tử khác, thanh toán di động, hệ thống thẻ ra vào, v.v., hoạt động trong phạm vi dưới 10cm. NFC được sử dụng chủ yếu cho thanh toán và truyền dữ liệu đơn giản nhờ tốc độ nhanh và khả năng sử dụng dễ dàng.',
      dot: '',
    },
    {
      head: 'Nguyên lý hoạt động của NFC',
      subHead: '',
      desc: 'Nguyên lý hoạt động của NFC (công nghệ giao tiếp tầm gần) rất hiệu quả và đơn giản. Đầu tiên, NFC tạo ra một trường điện từ nhỏ giữa các thiết bị. Trường này đóng vai trò là kênh cần thiết để trao đổi dữ liệu, tương tự như khái niệm được sử dụng trong radar. Trường điện từ nhỏ này chỉ hoạt động hiệu quả ở khoảng cách rất gần giữa các thiết bị, thường là trong phạm vi dưới 10cm.\nNguyên lý hoạt động của NFC dựa trên công nghệ RFID (Radio-Frequency Identification). Do đó, dữ liệu được trao đổi không dây giữa thiết bị truyền (Đầu đọc - Reader hoặc thiết bị khởi tạo) và thiết bị nhận (Thẻ - Tag hoặc thẻ). Lúc này, thông qua trường điện từ, cả hai thiết bị nhận diện và bắt đầu giao tiếp với nhau.\nMột trong những đặc điểm chính là khoảng cách hoạt động của NFC tương đối ngắn. Điều này mang lại lợi thế về mặt bảo mật, ngăn chặn việc trao đổi dữ liệu không mong muốn. Ngoài ra, nguyên lý hoạt động này cho phép tốc độ truyền nhanh và trao đổi dữ liệu theo thời gian thực.',
      dot: '',
    },
    {
      head: 'Các ứng dụng chính của NFC',
      subHead: 'Thanh toán Di động NFC',
      desc: 'NFC chủ yếu được sử dụng để thanh toán tiện lợi bằng smartphone. Người dùng có thể nhanh chóng và tiện lợi hoàn tất thanh toán bằng cách đưa smartphone đến gần thiết bị đầu cuối thanh toán hỗ trợ NFC, truyền thông tin thanh toán đã được đăng ký trước. Các ví dụ điển hình bao gồm Apple Pay, Google Pay, Samsung Pay.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Chuyển dữ liệu',
      desc: 'NFC cho phép truyền dữ liệu đơn giản giữa hai thiết bị. Ví dụ, có thể dễ dàng trao đổi thông tin liên hệ, hình ảnh, danh thiếp, v.v., giữa các smartphone. Ngoài ra, có thể lập trình để việc truyền thông tin diễn ra tự động bằng cách sử dụng thẻ NFC.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Mở rộng chức năng của Smartphone',
      desc: 'NFC được sử dụng để mở rộng chức năng của smartphone. Ví dụ, có thể kết nối với hệ thống tự động hóa nhà thông minh và điều khiển đèn, hệ thống sưởi, hệ thống an ninh, v.v., bằng cách chạm smartphone vào một thiết bị cụ thể.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Thẻ ra vào điện tử',
      desc: 'NFC thường được sử dụng trong các hệ thống thẻ ra vào điện tử. Có thể vào các tòa nhà hoặc cơ sở vật chất thông qua smartphone hoặc thẻ NFC, mang lại tính bảo mật và tiện lợi cao hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Lĩnh vực Y tế',
      desc: 'NFC được ứng dụng hiệu quả trong nhiều lĩnh vực khác nhau như nhận diện bệnh nhân và kiểm soát truy cập, quản lý hồ sơ y tế và thuốc men, ứng phó tình huống khẩn cấp, và tự động hóa phòng khám. NFC góp phần tự động hóa hệ thống y tế một cách hiệu quả và tăng cường an toàn cho bệnh nhân, đồng thời giúp cung cấp dịch vụ y tế nhanh chóng và chính xác trong các tình huống khẩn cấp.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Công nghệ Smart POS',
      desc: 'NFC được liên kết với hệ thống Smart POS (Point of Sale) tại các cửa hàng hoặc quán cà phê để thanh toán và truyền thông tin giảm giá. Khách hàng có thể dễ dàng thanh toán bằng cách đưa smartphone đến gần thiết bị đầu cuối thanh toán.',
      dot: '',
    },
    {
      head: 'Sự khác biệt giữa NFC và Bluetooth',
      subHead: 'Khoảng cách giao tiếp',
      desc: 'NFC: Chỉ có thể giao tiếp ở khoảng cách rất gần, thường là dưới 10cm. Nó chủ yếu được sử dụng để truyền dữ liệu khi tiếp xúc hoặc ở khoảng cách rất gần.\nBluetooth: Hoạt động trong phạm vi rộng hơn nhiều, thường có thể giao tiếp lên đến 100 mét. Nó được sử dụng để truyền dữ liệu ở khoảng cách xa hơn và kết nối giữa các thiết bị.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tốc độ truyền dữ liệu',
      desc: 'NFC: Thường có tốc độ truyền dữ liệu chậm hơn so với Bluetooth. Nó chủ yếu được sử dụng để truyền một lượng nhỏ dữ liệu.\nBluetooth: Cung cấp tốc độ truyền dữ liệu cao, hiệu quả trong việc truyền một lượng lớn dữ liệu nhanh chóng.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Mục đích sử dụng',
      desc: 'NFC: Chủ yếu được sử dụng trong các ứng dụng tầm ngắn như trao đổi dữ liệu đơn giản, hệ thống thanh toán, và đọc thẻ (đọc thông tin lưu trữ trên thẻ).\nBluetooth: Chủ yếu được sử dụng trong các ứng dụng yêu cầu truyền dữ liệu tầm xa và dung lượng lớn như tai nghe, loa, bàn phím, v.v.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tiêu thụ điện năng',
      desc: 'NFC: Nổi tiếng với mức tiêu thụ điện năng thấp. Chủ yếu được sử dụng trong các thiết bị nhỏ không cần sạc.\nBluetooth: Có mức tiêu thụ điện năng tương đối cao, có thể ảnh hưởng đến tuổi thọ pin của một số thiết bị.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Bảo mật',
      desc: 'NFC: Vì chỉ có thể giao tiếp ở khoảng cách rất ngắn, nó thường được sử dụng trong môi trường tương đối an toàn.\nBluetooth: Có khả năng giao tiếp tầm xa, do đó bảo mật quan trọng hơn và đòi hỏi công nghệ bảo mật mạnh mẽ hơn.',
      dot: '',
    },
    {
      head: 'Triển vọng tương lai của NFC',
      subHead: '',
      desc: 'Công nghệ NFC tiếp tục phát triển và được kỳ vọng sẽ có nhiều ứng dụng trong các lĩnh vực đa dạng như thanh toán di động, nhà thông minh, và y tế. Với những đổi mới công nghệ liên tục nhằm cung cấp tính bảo mật tốt hơn và tốc độ truyền cao hơn, NFC được dự đoán sẽ đóng một vai trò quan trọng trong nhiều lĩnh vực công nghiệp khác nhau.\nNhư vậy, NFC là một trong những công nghệ truyền thông không dây quan trọng đang thúc đẩy đổi mới trong nhiều lĩnh vực khác nhau. Sự phát triển của nó được kỳ vọng sẽ mang lại nhiều đổi mới hơn nữa trong môi trường kỹ thuật số của tương lai.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: officeAsset.thumb,
        data: 'officeAsset',
        link: '/vi/enterprise/office/asset',
      },
    ],
  },
};
